import { takeEvery, put, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { IDENTITY_FORCE_LOGOUT_REQUEST } from '../actionTypes'
import { forceLogoutSuccess } from '../actions'
import { persistor } from 'store'

export default function* forceLogoutSaga() {
  yield takeEvery(IDENTITY_FORCE_LOGOUT_REQUEST, handleForceLogout)
}

export function* handleForceLogout() {
  yield call(persistor.flush)
  yield put(forceLogoutSuccess())
  yield put(push('/login'))
}
